import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-security-home',
  templateUrl: './security-home.component.html',
  styleUrls: ['./security-home.component.scss']
})
export class SecurityHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
